import { TbReportSearch } from "react-icons/tb";
import { AiFillSignal } from "react-icons/ai";
import { AiFillFilePdf } from "react-icons/ai";
import { BiUserPlus } from "react-icons/bi";
import { BiSolidReport } from "react-icons/bi";
import { FaRegFileArchive /*FaUsersCog*/ } from "react-icons/fa";
import { IoNotificationsCircleSharp } from "react-icons/io5";
import { TbTableOptions } from "react-icons/tb";
import { Link } from "react-router-dom";
import { HeaderIndex, FooterIndex } from "../../components/";
import "./index.css";

const HomePage = () => {
  return (
    <div>
      <HeaderIndex />
      <div className="container-botton">
        <div className="container-flex-buttons">
          <Link to="/informe">
            <div className="buttons-index">
              <div className="container-text-icons">
                <TbReportSearch className="icon-button" />
                <p className="text-button" id="informe">
                  Informe
                </p>
              </div>
            </div>
          </Link>

          <Link to="/detailMDR">
            <div className="buttons-index">
              <div className="container-text-icons">
                <AiFillSignal className="icon-button" />
                <p className="text-button">Matriz de Riesgo</p>
              </div>
            </div>
          </Link>

          <Link to="/cargar">
            <div className="buttons-index">
              <div className="container-text-icons">
                <FaRegFileArchive className="icon-button" />
                <p className="text-button">Cargar Archivo</p>
              </div>
            </div>
          </Link>

          {/*<Link to="/carga-proveedores">
            <div className="buttons-index">
              <div className="container-text-icons">
                <FaUsersCog className="icon-button" />
                <p className="text-button">Carga Proveedor</p>
              </div>
            </div>
           </Link>*/}

          <Link to="/crear-relacion">
            <div className="buttons-index">
              <div className="container-text-icons">
                <BiUserPlus className="icon-button" />
                <p className="text-button">Crear Relación</p>
              </div>
            </div>
          </Link>

          <Link to="/alertas">
            <div className="buttons-index">
              <div className="container-text-icons">
                <IoNotificationsCircleSharp className="icon-button" />
                <p className="text-button">Alertas</p>
              </div>
            </div>
          </Link>

          <Link to="/edit-matriz">
            <div className="buttons-index">
              <div className="container-text-icons">
                <TbTableOptions className="icon-button" />
                <p className="text-button">Variables de Matriz</p>
              </div>
            </div>
          </Link>

          <Link to="/reportes">
            <div className="buttons-index">
              <div className="container-text-icons">
                <BiSolidReport className="icon-button" />
                <p className="text-button">Reportes</p>
              </div>
            </div>
          </Link>

          <Link to="/Legajos">
            <div className="buttons-index">
              <div className="container-text-icons">
                <AiFillFilePdf className="icon-button" />
                <p className="text-button">Legajos</p>
              </div>
            </div>
          </Link>
        </div>
        <FooterIndex />
      </div>
    </div>
  );
};

export default HomePage;
